import * as React from 'react';
import { PrimaryButton, Dropdown, Stack, Spinner } from '@fluentui/react';
import { AddressEditor } from '../../components/create-visit/components/AddressEditor';
import { Address } from '../../api/address.types';
import { PARTNER_ADDRESS_TYPE } from '../../config/constants';
import { HealAPI } from '../../healApi';

export interface AddAddressFormProps {
  agencyId: string;
  onSuccess: () => void;
}

export interface AddAddressState {
  isSaving: boolean;
  address: Address;
  error?: string;
}

export class AddAddressForm extends React.Component<AddAddressFormProps, AddAddressState> {
  constructor(props: any) {
    super(props);
    this.state = {
      address: {
        addressType: PARTNER_ADDRESS_TYPE[0].key,
      } as any as Address,
      isSaving: false,
    };
  }

  public render(): JSX.Element {
    const { address, isSaving } = this.state;
    return (
      <Stack tokens={{ childrenGap: 16 }}>
        <Dropdown
          label="Address Type"
          required={true}
          selectedKey={address.addressType}
          options={PARTNER_ADDRESS_TYPE}
          onChange={(e, v) => this.setState({ address: { ...address, addressType: String(v!.key) } })}
        />
        <AddressEditor address={address} onChange={this.onAddressChange} />
        <PrimaryButton onClick={this.createAddress} className="flex-end" style={{ marginTop: 20 }} text="Add" disabled={!this.canSubmit() || isSaving} />
        {isSaving && <Spinner />}
      </Stack>
    );
  }

  private onAddressChange = (address: Address) => {
    this.setState({ address });
    this.setState({ error: undefined });
  };

  private canSubmit(): boolean {
    const { address } = this.state;
    return !!address.address && !!address.addressType && !!address.city && address.zipcode.length === 5;
  }

  private createAddress = () => {
    this.setState({ isSaving: true });
    HealAPI.addAddressToAgency(this.props.agencyId, this.state.address).then((response) => {
      if (response.ok) {
        this.props.onSuccess();
      }
      this.setState({ isSaving: false });
    });
  };
}
